import AdminComponent from "@/components/dashboard/AdminComponent";

import GrossInventorySearch from "@/views/search/GrossInventorySearch";
import GrossInventoryCreate from "@/views/create/GrossInventoryCreate.vue";

export default {
    path: "/gross-inventory",
    meta: {auth: true},
    component: AdminComponent,
    children: [
        {path: "search", name: "gross-inventory-search", component: GrossInventorySearch},
        {path: "create", name: "gross-inventory-create", component: GrossInventoryCreate},
    ]
}
